import { Button, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useLeaveTeamMutation } from '../../api/teams'
import modalEmitter from '../ModalComponent/modalEmitter'

type Props = {
  teamId: number
}

export function LeaveTeamModalBody({ teamId }: Props) {
  const [leaveTeam, leaveState] = useLeaveTeamMutation()
  const [message, setMessage] = useState('')

  const handleConfirm = async () => {
    if (leaveState.isLoading) return
    try {
      const trimmed = message.trim()
      await leaveTeam({ teamId, ...(trimmed.length > 0 ? { message: trimmed } : {}) }).unwrap()
      toast.success('Вы вышли из команды')
      modalEmitter.emitCloseModal()
    } catch {
      toast.error('Не удалось выйти из команды')
    }
  }

  return (
    <Stack gap={2}>
      <Typography>Вы уверены, что хотите выйти из команды?</Typography>
      <Typography variant="black-14-light">Сообщение (необязательно)</Typography>
      <TextField
        placeholder="Напишите причину или комментарий"
        multiline
        minRows={4}
        value={message}
        onChange={(e) => setMessage(e.target.value.slice(0, 500))}
        helperText={`${message.length}/500`}
        disabled={leaveState.isLoading}
        fullWidth
      />
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Button variant="follow" disabled={leaveState.isLoading} onClick={() => modalEmitter.emitCloseModal()}>
          Отмена
        </Button>
        <Button variant="danger" disabled={leaveState.isLoading} onClick={() => void handleConfirm()}>
          Подтвердить
        </Button>
      </Stack>
    </Stack>
  )
}

export function openLeaveTeamModal(teamId: number) {
  modalEmitter.emitOpenModal({
    dialog: {
      title: 'Выйти из команды',
      body: <LeaveTeamModalBody teamId={teamId} />,
      modalToCentrPosition: true,
    },
  })
}
